import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ApiRequestManager } from '@sb/library/api';
import { ApiError, DialogEvents, DialogManager, SimpleDialogData } from '@sb/library/base';
import { DialogWarningComponent } from '@sb/library/dialog';

@Injectable()
export class WidgetErrorManager implements ErrorHandler {

    private _handlingApiError = false;

    constructor(
        private _NgZone: NgZone,
        private _DialogManager: DialogManager,
        private _ApiRequestManager: ApiRequestManager
    ) {}

    handleError(error: any) {
        console.error(error);

        if (error instanceof ApiError) {
            if (!this._handlingApiError) {
                this._handlingApiError = true;
                this._ApiRequestManager.disabled = true;

                let text = $localize`:@@CommonAPIUnexpectedDialogText:Please refresh the page and try again, or contact support if the problem persists.`;
                if (error.Response.ErrorGUID) {
                    text += `<br/><br/><small data-clarity-unmask="true">Error code: ${error.Response.ErrorGUID}</small>`
                }

                this._NgZone.run(() =>
                    this._DialogManager.CreateDialog(DialogWarningComponent, new SimpleDialogData({
                        Title: $localize`:@@CommonAPIUnexpectedDialogTitle:Sorry, something unexpected occurred.`,
                        Text: text,
                        PrimaryButtonText: $localize`:@@CommonRefreshLabel:Refresh`,
                    }), null).events.subscribe(event => {
                        if (event === DialogEvents.PrimaryAction) {
                            window.location.reload();
                        }
                    })
                );
            }
        }
    }
}
